import { useRef, useState, useEffect } from 'react';

// Hook to provide refs and inline style for a sticky action element with a JS fallback
export default function useStickyAction() {
  const sentinelRef = useRef(null);
  const cardRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);
  const [style, setStyle] = useState(null);

  useEffect(() => {
    if (!sentinelRef.current || !cardRef.current) return;

    const updateFixedStyle = () => {
      if (!cardRef.current) return;
      const rect = cardRef.current.getBoundingClientRect();
      setStyle({ position: 'fixed', bottom: 0, left: rect.left + 'px', width: rect.width + 'px', zIndex: 1020 });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsFixed(false);
            setStyle(null);
          } else {
            setIsFixed(true);
            updateFixedStyle();
          }
        });
      },
      { root: null, threshold: 0 }
    );

    observer.observe(sentinelRef.current);

    const handleResize = () => {
      if (isFixed) updateFixedStyle();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, [isFixed]);

  return { sentinelRef, cardRef, style, isFixed };
}
